import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH, MIN_HEADER_DESKTOP_MENU, MOBILE_QUERY_MAX_WIDTH } from "constants/vp-sizes";
import { BRAND_BLACK_TEXT_COLOR, WHITE_COLOR_NAME, WORK_OS_IRIS_COLOR_NAME } from "styles/color-consts";
import Colors from "styles/colors";
import { LAYER_ONE } from "constants/z-index";
import styled from "@emotion/styled";
const MOBILE_DATE_COLOR = "#20303C";
export const StyledWhatsNewPageItemsList = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  max-width: ${`${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px`};
  width: 100%;

  .square-list {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding: 42px 24px 0;
    justify-content: center;
  }

  .square-wrapper {
    margin-left: 2%;
    display: flex;
    flex-direction: row;
    &.placeholder {
      height: 350px;
    }
  }

  .desktop-date-title {
    width: 100%;
    margin-left: 2%;
    display: flex;
    flex-direction: row;
  }

  .desktop-date-title .date-content {
    display: flex;
    flex-direction: row;
    font-size: 14px;
    line-height: 30px;
    padding: 24px 0;
    .popup-button-wrapper {
      display: flex;
      flex-direction: row;
    }
  }

  .square {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    width: 96%;
    margin: 16px 0;
    border-radius: 8px;
    box-shadow: 0 0 4px rgba(29, 140, 242, 0.16);
    position: relative;
    :hover {
      box-shadow: 0 0 16px rgba(29, 140, 242, 0.16);
    }
  }

  .line-dot-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 44px;
    position: relative;
  }

  .line-dot-container .vertical-line {
    width: 0.5px;
    height: 100%;
    background-color: ${Colors.silver};
    &.page-first-item {
      margin-top: 28px;
    }
  }

  .line-dot-container .dot {
    position: absolute;
    top: 34px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: ${Colors.silver};
  }

  .line-dot-container .date-dot {
    position: absolute;
    top: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: white;
  }

  .line-dot-container .date-dot .inner-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: ${Colors[WORK_OS_IRIS_COLOR_NAME]};
    z-index: ${LAYER_ONE};
  }

  .line-dot-container .date-dot .outer-ring {
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid;
    border-color: ${Colors[WORK_OS_IRIS_COLOR_NAME]};
    background-color: ${Colors[WHITE_COLOR_NAME]};
  }

  .square .content-wrapper {
    display: flex;
    flex-direction: column;
    width: 65%;
    padding: 18px;
    padding-bottom: 0;
  }

  .square .image-wrapper {
    width: 30%;
  }

  .square .tags-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .left-tags-wrapper {
      display: flex;
      margin-bottom: 8px;
      gap: 4px;
    }
  }

  .square .name {
    font-size: 1.25rem;
    font-weight: 600;
    margin-bottom: 8px;
    margin-top: 20px;
    text-align: left;
    line-height: 26px;
  }

  .square .description {
    font-size: 0.875rem;
    margin-bottom: 18px;
    text-align: left;
    line-height: 22px;
  }

  .pagination-wrapper {
    display: flex;
    flex-direction: row;
    width: 100%;
    margin-left: 2%;
  }

  .pagination {
    margin-top: 16px;
    margin-bottom: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding-bottom: 28px;

    .pagination-button {
      margin: 0 8px;
      cursor: pointer;
      text-decoration: none;
      font-size: 1.125rem;
      line-height: 22px;
      font-weight: 400;
    }

    span:not(.pagination-button) {
      font-size: 1.125rem;
      line-height: 22px;
      font-weight: 400;
    }
  }

  .square-list .empty-state {
    display: flex;
    flex-direction: column;
    .empty-state {
      width: 96%;
      padding: 16px 0 40px;
      margin-left: 2%;
      text-align: center;
      display: flex;
      gap: 8px;
      .empty-message-title {
        font-size: 1.25rem;
        font-weight: 600;
      }
      .empty-message-subtitle {
        font-size: 1rem;
        font-style: italic;
      }
    }
  }

  .square-list {
    display: flex;
    justify-content: flex-start;
    &.empty-list {
      justify-content: center;
    }
    .square-list-title {
      margin-left: calc(2% - 10px);
      margin-bottom: 16px;
      .core-title-container .core-title {
        font-weight: 300;
        font-size: 1.5rem;
      }
    }
  }

  .square .image-wrapper.mobile-image-wrapper {
    display: none;
  }

  .square .image-wrapper.desktop-image-wrapper {
    display: flex;
    height: 100%;
    border-radius: 8px;
    padding: 8px;
    .asset-inner .picture-component {
      display: flex;
      height: 100%;
      img {
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
      }
    }
  }

  .square .card-top-part-wrapper {
    display: flex;
    flex-direction: row;
    align-items: left;
  }

  .card-top-part-wrapper .release-type-name {
    font-size: 0.875rem;
  }

  .card-top-part-wrapper .separator-dot {
    display: inline-block;
    margin: 0 5px;
    vertical-align: middle;
    font-size: 1rem;
  }

  .square .content-wrapper .card-top-part-wrapper .release-type-icon .icon {
    width: 14px;
    margin-right: 4px;
  }

  .card-top-part-wrapper .full-date-title {
    font-size: 0.875rem;
    text-align: left;
    color: ${Colors[BRAND_BLACK_TEXT_COLOR]};
  }

  .square .read-more {
    padding-bottom: 16px;
  }

  @media (max-width: ${MIN_HEADER_DESKTOP_MENU}px) {
    .square .image-wrapper.desktop-image-wrapper {
      height: auto;
    }
  }

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
    flex-direction: column;

    .filters-container {
      display: none;
    }

    .square-list {
      padding-top: 0;
      gap: 24px;
      justify-content: unset;
      .square-list-title {
        display: none;
      }
    }

    .square-list .content-wrapper {
      width: 100%;
      padding: 0;
    }

    .square-list .content-wrapper .name {
      margin-bottom: 18px;
      margin-top: 0;
    }

    .square .image-wrapper.mobile-image-wrapper {
      display: flex;
      width: 100%;
    }

    .square .image-wrapper.desktop-image-wrapper {
      display: none;
    }

    .square .tags-wrapper {
      flex-wrap: wrap;
    }

    .square .tags-wrapper .left-tags-wrapper {
      flex-wrap: wrap;
      order: 1;
    }

    .square-wrapper .mobile-date-title {
      font-size: 0.875rem;
      text-align: left;
      color: ${MOBILE_DATE_COLOR};
    }

    .line-dot-container {
      display: none;
    }

    .square-wrapper {
      display: unset;
    }

    .square {
      border-bottom: 1px solid;
      border-color: ${Colors.gainsboro};
      border-radius: unset;
      box-shadow: unset;
      position: unset;
      padding: 32px 0;
      margin: unset;
      :hover {
        box-shadow: unset;
      }
    }

    .pagination-wrapper .line-dot-container {
      display: none;
    }

    .square .description {
      margin-bottom: 16px;
    }
  }
`;
